import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import { UtensilsCrossed, ShoppingBag } from 'lucide-react';

const OrderTypeScreen = () => {
    const navigate = useNavigate();
    const { setOrderType } = useAppContext();

    const handleSelect = (type) => {
        setOrderType(type);
        navigate('/payment-method'); // elegido el tipo, se pasa al pago
    };

    return (
        <div style={{
            position: 'fixed', inset: 0,
            background: 'transparent',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999,
        }}>
            <div style={{
                background: 'white', borderRadius: '2rem',
                padding: '4rem 3rem', textAlign: 'center',
                width: '90%', maxWidth: '520px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
            }}>
                <h2 style={{
                    fontSize: '2.4rem', fontWeight: '800',
                    color: '#383636', marginBottom: '2.5rem',
                    fontFamily: 'Quicksand, sans-serif',
                }}>
                    ¿Para dónde es tu pedido?
                </h2>
                <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center' }}>
                    <button onClick={() => handleSelect('servir')} style={{
                        flex: 1, padding: '2.5rem 1rem',
                        background: '#DA291C', color: 'white',
                        border: 'none', borderRadius: '1.2rem',
                        fontSize: '1.5rem', fontWeight: '700',
                        cursor: 'pointer', fontFamily: 'Quicksand, sans-serif',
                        display: 'flex', flexDirection: 'column',
                        alignItems: 'center', gap: '1.2rem',
                    }}>
                        <div style={{ width: 118, height: 118, borderRadius: '50%', background: 'rgba(255,255,255,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <UtensilsCrossed size={64} strokeWidth={1.4} />
                        </div>
                        PARA SERVIR
                    </button>
                    <button onClick={() => handleSelect('llevar')} style={{
                        flex: 1, padding: '2.5rem 1rem',
                        background: '#e1251b', color: 'white',
                        border: 'none', borderRadius: '1.2rem',
                        fontSize: '1.5rem', fontWeight: '700',
                        cursor: 'pointer', fontFamily: 'Quicksand, sans-serif',
                        display: 'flex', flexDirection: 'column',
                        alignItems: 'center', gap: '1.2rem',
                    }}>
                        <div style={{ width: 118, height: 118, borderRadius: '50%', background: 'rgba(255,255,255,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <ShoppingBag size={64} strokeWidth={1.4} />
                        </div>
                        PARA LLEVAR
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OrderTypeScreen;
